var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[(!_vm.errorPageCode)?_c('router-view'):_c('error-page',{attrs:{"error-code":_vm.errorPageCode}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }